import { render, staticRenderFns } from "./IP_RebillLog.vue?vue&type=template&id=6b132b06&scoped=true&"
import script from "./IP_RebillLog.vue?vue&type=script&lang=js&"
export * from "./IP_RebillLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b132b06",
  null
  
)

export default component.exports